/**
 * ScreenCheck Portal API
 * ScreenCheck Portal REST API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import AccessRule from './AccessRule';

/**
 * The AffectedMachine model module.
 * @module model/AffectedMachine
 * @version 0.0.1
 */
class AffectedMachine {
    /**
     * Constructs a new <code>AffectedMachine</code>.
     * @alias module:model/AffectedMachine
     */
    constructor() { 
        
        AffectedMachine.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AffectedMachine</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AffectedMachine} obj Optional instance to populate.
     * @return {module:model/AffectedMachine} The populated <code>AffectedMachine</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AffectedMachine();

            if (data.hasOwnProperty('machine_serial')) {
                obj['machine_serial'] = ApiClient.convertToType(data['machine_serial'], 'String');
            }
            if (data.hasOwnProperty('access_rules')) {
                obj['access_rules'] = ApiClient.convertToType(data['access_rules'], [AccessRule]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AffectedMachine</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AffectedMachine</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['machine_serial'] && !(typeof data['machine_serial'] === 'string' || data['machine_serial'] instanceof String)) {
            throw new Error("Expected the field `machine_serial` to be a primitive type in the JSON string but got " + data['machine_serial']);
        }
        if (data['access_rules']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['access_rules'])) {
                throw new Error("Expected the field `access_rules` to be an array in the JSON data but got " + data['access_rules']);
            }
            // validate the optional field `access_rules` (array)
            for (const item of data['access_rules']) {
                AccessRule.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {String} machine_serial
 */
AffectedMachine.prototype['machine_serial'] = undefined;

/**
 * @member {Array.<module:model/AccessRule>} access_rules
 */
AffectedMachine.prototype['access_rules'] = undefined;






export default AffectedMachine;

